import React, { useContext, useEffect, useRef } from 'react';
import CalendarTeaser from '../calendar-teaser/CalendarTeaser.jsx';
import { CalendarContext } from '../calendar/javascripts/context/CalendarContext.jsx';

export default function CalendarBlock({ headline, topline, items, month, id }) {
  const { updateActiveMonth } = useContext(CalendarContext);

  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) updateActiveMonth(month);
      },
      { threshold: 1 }
    );

    observer.observe(ref.current);
  }, [ref]);

  let prevEventType = null;
  let prevProductionId = null;

  return (
    <div className="calendar-block" id={id} ref={ref}>
      {headline && (
        <div className="calendar-block__intro">
          <div data-grid="full">
            <div className="calendar-block__headline">
              <div>
                {topline && <p className="text text--meta">{topline}</p>}
                <h3 className="text text--subline">{headline}</h3>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="calendar-block__items">
        {items.length > 0 &&
          items.map((item) => {
            const borderType =
              (prevEventType === 'additional' || item.eventType === 'additional') && item.productionId === prevProductionId ? 'lines' : 'solid';

            prevEventType = item.eventType;
            prevProductionId = item.productionId;

            return <CalendarTeaser key={item.id} borderType={borderType} {...item} />;
          })}
      </div>
    </div>
  );
}
